import styled, { css } from 'styled-components';
import { PROMOTION_TYPES } from '@/domainLogic/index.ts';
import { priceContainerWidthStyle } from '../../utils/styled';

export const promotionColors = css<{
  lastMinuteDeals?: boolean;
  promotionType?: PROMOTION_TYPES | null;
  isWhiteLabel?: boolean;
}>`
  ${({ promotionType, lastMinuteDeals }) => {
    if (promotionType === PROMOTION_TYPES.FLASH_SALES && lastMinuteDeals) {
      return css`
        color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
        text-decoration-color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
      `;
    } else if (promotionType === PROMOTION_TYPES.FLASH_SALES) {
      return css`
        color: ${({ theme }) => theme.kallisto.color.common.special.flashSales[500]};
        text-decoration-color: ${({ theme }) => theme.kallisto.color.common.special.flashSales[500]};
      `;
    } else if (promotionType === PROMOTION_TYPES.MY_PRICE) {
      return css`
        color: ${({ theme }) => theme.kallisto.color.common.special.myPrice[700]};
        text-decoration-color: ${({ theme }) => theme.kallisto.color.common.special.myPrice[700]};
      `;
    } else if (promotionType === PROMOTION_TYPES.TOP_SECRET_HOTELS) {
      return css`
        color: ${({ theme }) => theme.kallisto.color.common.special.topSecretHotels[900]};
        text-decoration-color: ${({ theme }) => theme.kallisto.color.common.special.topSecretHotels[900]};
      `;
    } else {
      return css``;
    }
  }}
`;

const priceBoxShadow = css`
  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: -16px;
    bottom: 0;
    width: 16px;
    box-shadow:
      -16px 0 20px -16px rgba(0, 0, 0, 0.04) inset,
      -16px 0 10px -16px rgba(0, 0, 0, 0.04) inset,
      -16px 0 4px -16px rgba(0, 0, 0, 0.02) inset;
  }
`;

const desktopStyles = css`
  ${priceBoxShadow};
  height: 100%;
  padding: 16px;
`;

const overlayDesktop = css`
  width: 100%;
  margin-top: 4px;
  padding: 0 12px 8px;

  &:before {
    content: unset;
  }
`;

const overlayMobile = css`
  margin-top: auto;
  width: auto;
  height: unset;
  padding-top: 0;
`;

const waitingStyles = css`
  flex-direction: column;
  align-items: flex-end;
  & > * {
    margin-top: unset;
  }
`;

export const PriceContainer = styled.div<{
  isOverlay: boolean;
  isWaiting: boolean;
  isOverlayAndMobile?: boolean;
  hasAgeText?: boolean;
  hasTaxesText?: boolean;
  ref?: React.MutableRefObject<HTMLDivElement | undefined>;
}>`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  position: relative;
  padding: 12px 16px 16px;
  ${priceContainerWidthStyle};

  @media (max-width: 767px) {
    ${({ isOverlay }) => isOverlay && overlayMobile};
  }

  @media (min-width: 768px) {
    ${desktopStyles};
    ${({ isOverlay }) => isOverlay && overlayDesktop};
  }

  ${({ isOverlay }) => isOverlay && overlayDesktop};
  ${({ isWaiting }) => isWaiting && waitingStyles}
`;

export const BadgesContainer = styled.div`
  max-width: 100%;
  margin-bottom: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;

  @media (max-width: 1190px) {
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
    flex-wrap: wrap;
  }
`;
